export const SPACE_TYPES = [
  { value: "familiar", label: "Familiar", icon: "🏡", description: "Organiza tu familia: calendario, compras y recuerdos" },
  { value: "empresa", label: "Empresa", icon: "💼", description: "Equipos de trabajo, proyectos y documentos" },
  { value: "club", label: "Club", icon: "⚽", description: "Asociaciones, clubes deportivos y comunidades" },
  { value: "personalizado", label: "Personalizado", icon: "✨", description: "Configura tu Espacio a tu manera" },
];

export const SPACE_COLORS = ["#1A73E8", "#D93025", "#1E8E3E", "#F9AB00", "#9D4CDD", "#FF7043", "#26A69A", "#EC407A"];

export const SPACE_ICONS = ["🏡", "💼", "⚽", "✨", "🌍", "🎉", "📚", "🏖️", "🎾", "🍽️", "🚀", "🎵", "🐾", "💪", "🧭", "🏗️"];

export const ROLE_OPTIONS = [
  { value: "admin", label: "Administrador" },
  { value: "member", label: "Miembro" },
  { value: "guest", label: "Invitado" },
];

export const ACTION_LABELS = {
  workspace_created: "creó el Espacio",
  workspace_updated: "actualizó la configuración",
  workspace_archived: "archivó el Espacio",
  ownership_transferred: "transfirió la propiedad",
  member_updated: "modificó un miembro",
  member_removed: "eliminó a un miembro",
  member_left: "abandonó el Espacio",
  member_joined: "se unió al Espacio",
  invitation_created: "creó una invitación",
  invitation_revoked: "revocó una invitación",
  team_created: "creó un equipo",
  team_updated: "actualizó un equipo",
  team_deleted: "eliminó un equipo",
  project_created: "creó el proyecto",
  project_updated: "actualizó el proyecto",
  project_archived: "archivó el proyecto",
  project_deleted: "eliminó el proyecto",
  task_completed: "completó la tarea",
  file_uploaded: "subió el archivo",
  file_replaced: "reemplazó el archivo",
  file_deleted: "eliminó el archivo",
  album_created: "creó el álbum",
  poll_created: "creó la encuesta",
  poll_closed: "cerró la encuesta",
  expense_created: "registró el gasto",
  expense_deleted: "eliminó el gasto",
  settlement_created: "registró una liquidación",
  budget_created: "creó el presupuesto",
};

export function timeAgo(iso) {
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return "hace un momento";
  if (diff < 3600) return `hace ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `hace ${Math.floor(diff / 3600)} h`;
  if (diff < 604800) return `hace ${Math.floor(diff / 86400)} d`;
  return new Date(iso).toLocaleDateString("es-ES", { day: "numeric", month: "short" });
}

export function greeting(name) {
  const h = new Date().getHours();
  const first = (name || "").split(" ")[0];
  if (h < 7) return `Buenas noches, ${first}`;
  if (h < 13) return `Buenos días, ${first}`;
  if (h < 21) return `Buenas tardes, ${first}`;
  return `Buenas noches, ${first}`;
}
